module.exports = __webpack_public_path__ + "static/media/image1.c8e742d9.png";